import { NgModule } from '@angular/core';
import { PreloadAllModules } from '@angular/router';
import { Routes } from '@angular/router';
import { RouterModule } from '@angular/router';

import { AuthGuard } from './user/auth.guard';
import { LoginComponent } from './user/login/login.component';
import { RegisterComponent } from './user/register/register.component';
import { PasswordChangeComponent } from './user/password-change/password-change.component';
import { PasswordRecoverComponent } from './user/password-recover/password-recover.component';
import { ShellComponent } from './core/shell/shell.component';

const routes: Routes = [
  {
    path: 'verification/:verificationId',
    loadChildren: './verification/verification.module#VerificationModule'
  },
  {
    path: 'acumatica',
    loadChildren: './acumatica/acumatica.module#AcumaticaModule'
  },
  {
    path: 'acumatica/verification/:id',
    loadChildren: './verification/verification.module#VerificationModule'
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'ABBYY FlexiCapture Cloud Sign in'
    }
  },
  {
    path: 'register',
    component: RegisterComponent,
    data: {
      title: 'ABBYY FlexiCapture Cloud Registration'
    }
  },
  {
    path: 'password/change/:token',
    component: PasswordChangeComponent
  },
  {
    path: 'password/recover',
    component: PasswordRecoverComponent
  },
  {
    path: '',
    component: ShellComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'invoices'
      },
      {
        path: 'documents',
        loadChildren: './documents/documents.module#DocumentsModule'
      },
      {
        path: 'invoices',
        loadChildren: './documents/documents.module#DocumentsModule'
      },
      {
        path: 'documents/applications',
        loadChildren: './applications/applications.module#ApplicationsModule'
      },
      {
        path: 'invoices/applications',
        loadChildren: './applications/applications.module#ApplicationsModule'
      },
      {
        path: 'verification',
        loadChildren: './verification/verification.module#VerificationModule'
      },
      {
        path: 'documents/quick-start-guide',
        loadChildren: './guide/guide.module#GuideModule'
      },
      {
        path: 'documents/api-description',
        loadChildren: './api/api.module#ApiModule'
      },
      {
        path: 'invoices/quick-start-guide',
        loadChildren: './guide/guide.module#GuideModule'
      },
      {
        path: 'invoices/api-description',
        loadChildren: './api/api.module#ApiModule'
      },
      {
        path: 'setup/import',
        loadChildren: './import/import.module#ImportModule'
      },
      {
        path: 'setup/integration',
        loadChildren: './export/export.module#ExportModule'
      },
      {
        path: 'import/email/log',
        loadChildren: './import/log/import-log.module#ImportLogModule'
      },
      {
        path: 'admin/applications',
        loadChildren: './superadmin/superadmin.module#SuperadminModule'
      },
      {
        path: 'statistics',
        loadChildren: './statistics/statistics.module#StatisticsModule'
      },
      {
        path: 'usage-report',
        loadChildren: './usage-report/usage-report.module#UsageReportModule'
      }
    ]
  },
  {
    path: 'external',
    loadChildren: './external/external.module#ExternalModule'
  },
  {
    path: '**',
    redirectTo: 'documents'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule],
  providers: [AuthGuard]
})
export class AppRoutingModule { }
